import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/plus-active.svg'
import _imports_1 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_2 from '@/app/ui/assets/svg/ban.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-ba2b4052")

_pushScopeId("data-v-ba2b4052")
const _hoisted_1 = { class: "pt-0 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full partner-update" }
const _hoisted_2 = { class: "inline-flex" }
const _hoisted_3 = { class: "w-17/20" }
const _hoisted_4 = { class: "flex flex-row mt-5" }
const _hoisted_5 = { class: "w-2/4 mr-6" }
const _hoisted_6 = { class: "w-2/4" }
const _hoisted_7 = { class: "grid grid-cols-2 mt-4 gap-6" }
const _hoisted_8 = { class: "flex flex-row mt-4" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = { class: "flex flex-row mt-4" }
const _hoisted_11 = { class: "w-2/4 mr-6" }
const _hoisted_12 = {
  key: 0,
  class: "w-2/4"
}
const _hoisted_13 = {
  key: 1,
  class: "w-2/4"
}
const _hoisted_14 = {
  key: 0,
  class: "flex flex-row mt-4"
}
const _hoisted_15 = { class: "w-2/4 mr-6" }
const _hoisted_16 = { class: "w-2/4" }
const _hoisted_17 = {
  key: 1,
  class: "flex flex-row mt-4"
}
const _hoisted_18 = { class: "w-2/4 mr-6" }
const _hoisted_19 = { class: "w-2/4" }
const _hoisted_20 = {
  key: 2,
  class: "flex flex-row mt-4"
}
const _hoisted_21 = { class: "w-2/4 mr-6" }
const _hoisted_22 = { class: "w-2/4" }
const _hoisted_23 = { class: "flex flex-row mt-4" }
const _hoisted_24 = { class: "w-2/4 mr-6" }
const _hoisted_25 = { class: "w-2/4" }
const _hoisted_26 = {
  key: 3,
  class: "flex flex-row mt-4"
}
const _hoisted_27 = { class: "w-2/4 mr-6" }
const _hoisted_28 = {
  key: 0,
  class: "w-2/4"
}
const _hoisted_29 = {
  key: 1,
  class: "w-2/4"
}
const _hoisted_30 = {
  key: 4,
  class: "flex flex-row mt-4"
}
const _hoisted_31 = { class: "w-2/4 mr-6" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "w-2/4" }, null, -1)
const _hoisted_33 = { class: "w-2/4" }
const _hoisted_34 = { class: "text-red-lp-100 text-12px" }
const _hoisted_35 = {
  key: 0,
  class: "flex flex-row mt-4 relative"
}
const _hoisted_36 = {
  key: 1,
  class: "flex flex-row mt-4 relative"
}
const _hoisted_37 = {
  key: 2,
  class: "flex flex-row mt-4 relative"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_39 = {
  key: 3,
  class: "w-17/20"
}
const _hoisted_40 = {
  key: 4,
  class: "border-t my-6 border-gray-lp-400"
}
const _hoisted_41 = { class: "w-17/20" }
const _hoisted_42 = { class: "flex flex-row gap-x-6 mt-4" }
const _hoisted_43 = { class: "w-6/12 space-y-6" }
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "plus-active"
}, null, -1)
const _hoisted_45 = { class: "w-6/12 space-y-6" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_47 = { class: "w-17/20" }
const _hoisted_48 = { class: "text-12px text-gray-lp-500 w-8/12 my-2" }
const _hoisted_49 = { class: "flex flex-row mt-4" }
const _hoisted_50 = { class: "w-2/4 mr-6" }
const _hoisted_51 = { class: "w-2/4" }
const _hoisted_52 = {
  key: 0,
  class: "flex flex-row mt-4"
}
const _hoisted_53 = { class: "w-12/12" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_56 = { class: "flex flex-row mt-4" }
const _hoisted_57 = { class: "w-2/4 mr-6" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_59 = { class: "grid gap-y-8 text-black-lp-300" }
const _hoisted_60 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_61 = {
  key: 0,
  class: "w-28"
}
const _hoisted_62 = { class: "flex-grow" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" a.n ")
const _hoisted_64 = { class: "font-semibold" }
const _hoisted_65 = { style: {"width":"86px"} }
const _hoisted_66 = {
  key: 5,
  class: "border-t my-5 border-gray-lp-400"
}
const _hoisted_67 = {
  key: 6,
  class: "grid gap-y-4 text-black-lp-300 w-17/20"
}
const _hoisted_68 = { class: "flex flex-row" }
const _hoisted_69 = { class: "w-2/4 mr-6" }
const _hoisted_70 = { class: "w-2/4" }
const _hoisted_71 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_72 = { class: "font-semibold" }
const _hoisted_73 = { class: "my-1 font-normal" }
const _hoisted_74 = { class: "flex" }
const _hoisted_75 = { class: "capitalize" }
const _hoisted_76 = { class: "font-semibold mt-5" }
const _hoisted_77 = { class: "my-1 font-normal" }
const _hoisted_78 = { class: "flex" }
const _hoisted_79 = {
  key: 0,
  class: "flex font-medium text-red-lp-300"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("img", {
  class: "mr-1",
  src: _imports_2,
  alt: "ban"
}, null, -1)
const _hoisted_81 = {
  key: 1,
  class: "my-1 font-normal mt-2"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_83 = { class: "text-black-lp-300 text-12px xxl:text-14px mt-4" }
const _hoisted_84 = { class: "font-semibold" }
const _hoisted_85 = { class: "my-1 font-normal mt-2" }
const _hoisted_86 = { class: "text-gray-lp-500" }
const _hoisted_87 = { class: "text-black-lp-300 text-12px xxl:text-14px mt-5" }
const _hoisted_88 = { class: "font-semibold" }
const _hoisted_89 = { class: "my-1 font-normal mt-2" }
const _hoisted_90 = { class: "text-gray-lp-500" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_SectionAreaDelivery = _resolveComponent("SectionAreaDelivery")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FileAttachment = _resolveComponent("FileAttachment")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAddBank = _resolveComponent("ModalAddBank")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_DetailLayout, {
        scrollSidebar: "",
        title: _ctx.getTitle,
        onBack: _ctx.goBack,
        onConfirm: _ctx.goBack,
        loading: _ctx.isLoading
      }, {
        "top-right": _withId(() => [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_button_fill, {
                isDisabled: _ctx.validateForm || _ctx.validateParent,
                onClick: _ctx.updateConfirmation,
                title: _ctx.$t('Simpan'),
                class: "px-8 bg-red-lp-300",
                "data-testid": "partner-edit-save-button"
              }, null, 8, ["isDisabled", "onClick", "title"])
            ])
          ])
        ]),
        data: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Title, { label: "Detail Partner" }),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_DataWrapper, {
                    label: `${_ctx.$t('partnerManagement.code')} ` + _ctx.partnerName
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_lp_input, {
                        placeholder: "XXXXXXX",
                        disabled: "",
                        modelValue: _ctx.detailData.partnerCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.partnerCode = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_DataWrapper, {
                    label: `${_ctx.$t('partnerManagement.code')} Elexys`
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_lp_input, {
                        disabled: "",
                        modelValue: _ctx.detailData.partnerElexysCode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.partnerElexysCode = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_DataWrapper, {
                  label: `${_ctx.$t('partnerManagement.name')} ` + _ctx.partnerName
                }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.partnerName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.partnerName = $event)),
                      placeholder: _ctx.$t('partnerManagement.route.changePartnerName')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.route.changePartnerName'),
                  tooltipDescription: _ctx.$t('partnerManagement.route.posReturnSttDesc'),
                  optional: ""
                }, {
                  default: _withId(() => [
                    _createVNode(_component_SelectSearch, {
                      options: _ctx.posReverseJourney,
                      onFilter: _ctx.filterPartnerPosReverseJourney,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('partnerManagement.route.choosePosName'),
                      modelValue: _ctx.detailData.partnerPosReverseJourney,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailData.partnerPosReverseJourney = $event)),
                      isLoading: _ctx.isLoadingParentPos,
                      class: "my-2",
                      isDisabled: !_ctx.detailData.partnerDistrictCode,
                      onChange: _ctx.filterPartnerPosReverseJourney
                    }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "isDisabled", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label", "tooltipDescription"])
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.route.address')
                }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.partnerAddress,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailData.partnerAddress = $event)),
                      type: "textarea",
                      placeholder: _ctx.$t('partnerManagement.route.partnerAddress')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.kecamatanKota')
                }, {
                  default: _withId(() => [
                    _createVNode(_component_SelectSearch, {
                      "is-show-error-indicator": _ctx.errorKecamatanKota,
                      "error-caption": _ctx.errorCaptionKecamatanKota,
                      options: _ctx.districts,
                      onFilter: _ctx.fetchDistricts,
                      isLoading: _ctx.isLoadingDistricts,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('partnerManagement.list.enterLocation'),
                      modelValue: _ctx.detailData.partnerDistrict,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.detailData.partnerDistrict = $event)),
                      onChange: _ctx.getConsolidatorsByCity,
                      class: "my-2",
                      "data-testid": "partner-edit-district-select"
                    }, null, 8, ["is-show-error-indicator", "error-caption", "options", "onFilter", "isLoading", "placeholder", "modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              (_ctx.detailData.partnerType === 'console')
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.additionalCity'),
                      icon: "info",
                      iconActive: "info-red",
                      tooltipTitle: _ctx.$t('partnerManagement.list.additionalCity'),
                      tooltipDescription: _ctx.$t('partnerManagement.list.additionalCityDesc')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_MultipleSelectSearch, {
                          options: _ctx.cityListData,
                          onFilter: _ctx.filterCityList,
                          modelValue: _ctx.detailData.partnerCity,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.detailData.partnerCity = $event)),
                          keyName: "name",
                          keyValue: "code",
                          optionName: _ctx.$t('partnerManagement.list.city'),
                          error: _ctx.cityOver,
                          errorCaption: _ctx.$t('partnerManagement.list.maxAdditionalCity'),
                          placeholder: _ctx.$t('partnerManagement.list.enterCity')
                        }, null, 8, ["options", "onFilter", "modelValue", "optionName", "error", "errorCaption", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label", "tooltipTitle", "tooltipDescription"])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_13))
            ]),
            (_ctx.detailData.partnerType === 'sub-console')
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.consoleName'),
                      optional: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_SelectSearch, {
                          options: _ctx.consolidators,
                          onFilter: _ctx.filterSubconsolidators,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: _ctx.$t('partnerManagement.list.consoleNameDesc'),
                          modelValue: _ctx.modelSubconsolidator,
                          "onUpdate:modelValue": _ctx.onChangePartnerOwnership,
                          isLoading: _ctx.isLoadingConsolidators,
                          class: "my-2"
                        }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "onUpdate:modelValue", "isLoading"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.namaPartnerArea')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_SelectSearch, {
                          options: _ctx.consolidators,
                          onFilter: _ctx.filterConsolidators,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: _ctx.$t('partnerManagement.list.enterPartner'),
                          modelValue: _ctx.modelPartnerParent,
                          "onUpdate:modelValue": _ctx.onChangePartnerParent,
                          isLoading: _ctx.isLoadingConsolidators,
                          class: "my-2"
                        }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "onUpdate:modelValue", "isLoading"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.detailData.partnerType === 'console')
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.detail.phone')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          prefix: _ctx.districtFieldRules.phoneDialCode,
                          debounce: 500,
                          format: _ctx.formatNumber,
                          modelValue: _ctx.detailData.partnerPhoneNumber,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.detailData.partnerPhoneNumber = $event)),
                          error: _ctx.error.phone || _ctx.errorMinimalPhone(),
                          onChange: _ctx.validatePhone,
                          errorCaption: "Masukan No. Telepon dengan benar",
                          maxLength: "13",
                          placeholder: "e.g 2112341234",
                          "data-testid": "partner-edit-console-phone-input"
                        }, null, 8, ["prefix", "format", "modelValue", "error", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.tax')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          modelValue: _ctx.detailData.partnerTaxNumber,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.detailData.partnerTaxNumber = $event)),
                          format: _ctx.formatTax,
                          onChange: _ctx.validateTaxNumber,
                          errorCaption: _ctx.$t('partnerManagement.error.enterTax'),
                          error: _ctx.error.taxNumber,
                          placeholder: _ctx.taxPlaceholder,
                          maxLength: _ctx.taxMaxLength,
                          "show-max-length": "",
                          "data-testid": "partner-edit-tax-id-input"
                        }, null, 8, ["modelValue", "format", "onChange", "errorCaption", "error", "placeholder", "maxLength"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.detailData.partnerType === 'pos')
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.partnerType')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectPartnerType,
                          onCloseSelect: _ctx.onCloseSelectPartnerType,
                          isOpenMenu: _ctx.isOpenPartnerType,
                          value: _ctx.detailData.partnerParentType,
                          onChooseSelect: _ctx.onSelectPartnerType,
                          dataSelect: _ctx.partnerAreaTypeList,
                          class: "w-full whitespace-no-wrap my-2 z-10"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.partnerType')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_SelectSearch, {
                          options: _ctx.consolidators,
                          onFilter: _ctx.filterConsolidators,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: _ctx.$t('partnerManagement.list.enterPartner'),
                          modelValue: _ctx.modelPartnerParent,
                          "onUpdate:modelValue": _ctx.onChangePartnerParent,
                          isLoading: _ctx.isLoadingConsolidators,
                          class: "my-2"
                        }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "onUpdate:modelValue", "isLoading"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_DataWrapper, { label: "Latitude" }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      format: _ctx.formatLatLong,
                      modelValue: _ctx.detailData.partnerLatitude,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailData.partnerLatitude = $event)),
                      placeholder: _ctx.$t('partnerManagement.list.enterLatitude')
                    }, null, 8, ["format", "modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_DataWrapper, { label: "Longitude" }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      format: _ctx.formatLatLong,
                      modelValue: _ctx.detailData.partnerLongitude,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailData.partnerLongitude = $event)),
                      placeholder: _ctx.$t('partnerManagement.list.enterLongtitude')
                    }, null, 8, ["format", "modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.detailData.partnerType === 'pos')
              ? (_openBlock(), _createBlock("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.tipePos')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_Select, {
                          class: "w-full my-2",
                          dataSelect: _ctx.typePos,
                          onOpenSelect: () => (_ctx.openTypePos = true),
                          onCloseSelect: () => (_ctx.openTypePos = false),
                          onChooseSelect: _ctx.onChangeTypePos,
                          value: _ctx.detailData.partnerPosType,
                          isOpenMenu: _ctx.openTypePos
                        }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  (_ctx.detailData.partnerPosType === 'branch' || _ctx.detailData.partnerPosType === 'pickup')
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        _createVNode(_component_DataWrapper, { label: "POS Parent" }, {
                          default: _withId(() => [
                            _createVNode(_component_SelectSearch, {
                              options: _ctx.parentPos,
                              onFilter: _ctx.filterParentPos,
                              keyName: "name",
                              keyValue: "id",
                              placeholder: _ctx.$t('partnerManagement.list.typePosParent'),
                              modelValue: _ctx.detailData.partnerPosParentName,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.detailData.partnerPosParentName = $event)),
                              isLoading: _ctx.isLoadingParentPos,
                              class: "my-2",
                              isDisabled: !_ctx.detailData.partnerDistrict,
                              onChange: _ctx.setPartnerPosParentId
                            }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "isDisabled", "onChange"])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_ctx.detailData.partnerPosType === 'parent' || !_ctx.detailData.partnerPosType)
                      ? (_openBlock(), _createBlock("div", _hoisted_29, [
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('partnerManagement.list.posOwnerName'),
                            optional: ""
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_SelectSearch, {
                                options: _ctx.subconsolidators,
                                onFilter: _ctx.filterSubconsolidators,
                                keyName: "name",
                                keyValue: "id",
                                placeholder: _ctx.$t('partnerManagement.list.typePosOwner'),
                                modelValue: _ctx.detailData.partnerOwnershipName,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.detailData.partnerOwnershipName = $event)),
                                isLoading: _ctx.isLoadingConsolidators,
                                class: "my-2",
                                isDisabled: !_ctx.detailData.partnerDistrict,
                                onChange: _ctx.setPartnerOwnershipId
                              }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "isDisabled", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.detailData.partnerType === 'pos' && _ctx.detailData.partnerPosType !== 'parent' && _ctx.detailData.partnerPosType)
              ? (_openBlock(), _createBlock("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.posOwnerName'),
                      optional: ""
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_SelectSearch, {
                          options: _ctx.subconsolidators,
                          onFilter: _ctx.filterSubconsolidators,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: _ctx.$t('partnerManagement.list.typePosOwner'),
                          modelValue: _ctx.detailData.partnerOwnershipName,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.detailData.partnerOwnershipName = $event)),
                          isLoading: _ctx.isLoadingConsolidators,
                          class: "my-2",
                          isDisabled: !_ctx.detailData.partnerDistrict,
                          onChange: _ctx.setPartnerOwnershipId
                        }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "isDisabled", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _hoisted_32
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_33, [
              _withDirectives(_createVNode(_component_DataWrapper, {
                label: _ctx.$t('partnerManagement.list.posCommition')
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: _ctx.$t('partnerManagement.list.enterPosCommition'),
                    modelValue: _ctx.detailData.partnerPosBranchCommission,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.detailData.partnerPosBranchCommission = $event)),
                    format: _ctx.formatCommission,
                    error: _ctx.error.commision,
                    onChange: _ctx.validateCommision,
                    errorCaption: _ctx.errorCaptionCommision,
                    min: "0",
                    max: "100",
                    suffix: "%",
                    disabled: ""
                  }, null, 8, ["placeholder", "modelValue", "format", "error", "onChange", "errorCaption"]),
                  _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('partnerManagement.list.posCommitionDesc')), 1)
                ]),
                _: 1
              }, 8, ["label"]), [
                [_vShow, _ctx.detailData.partnerPosType === 'branch']
              ])
            ])
          ]),
          (_ctx.detailData.partnerType === 'pos')
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode(_component_CheckboxV2, {
                  label: "COD Delivery Partner",
                  class: "w-2/4",
                  hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                  textSize: 14,
                  keyName: "CODDeliveryPartnerUpdate",
                  value: _ctx.detailData.partnerIsCodDelivery,
                  "onUpdate:value": _ctx.onCheckedCODDeliveryPartner
                }, null, 8, ["hint", "value", "onUpdate:value"]),
                _createVNode(_component_CheckboxV2, {
                  label: "COD Booking Partner",
                  hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                  textSize: 14,
                  keyName: "CODBookingPartnerAdd",
                  value: _ctx.detailData.partnerIsCodBooking,
                  "onUpdate:value": _ctx.onCheckedCODBookingPartner
                }, null, 8, ["hint", "value", "onUpdate:value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.detailData.partnerType === 'pos')
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _createVNode(_component_CheckboxV2, {
                  label: "PCU",
                  class: "w-2/4",
                  hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                  textSize: 14,
                  keyName: "PartnerPcuUpdate",
                  value: _ctx.detailData.partnerIsPcu,
                  "onUpdate:value": _ctx.onCheckedPartnerIsPCU
                }, null, 8, ["hint", "value", "onUpdate:value"]),
                _createVNode(_component_CheckboxV2, {
                  label: "Booking Vippack",
                  class: "w-2/4",
                  hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                  textSize: 14,
                  keyName: "partnerIsAllowBookVippack",
                  value: _ctx.detailData.partnerIsAllowBookVippack,
                  "onUpdate:value": _ctx.onCheckedPartnerIsAllowBookVippack
                }, null, 8, ["hint", "value", "onUpdate:value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.detailData.partnerType === 'pos')
            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                _createVNode(_component_CheckboxV2, {
                  label: "POS Ownsales",
                  class: "w-2/4",
                  hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                  textSize: 14,
                  keyName: "PartnerIsOwnsales",
                  value: _ctx.detailData.partnerIsPosOwnSales,
                  "onUpdate:value": _ctx.onCheckedPartnerIsPosOwnSales
                }, null, 8, ["hint", "value", "onUpdate:value"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_38,
          (_ctx.detailData.partnerType === 'console' && _ctx.isShowAreaDeliverySection)
            ? (_openBlock(), _createBlock("div", _hoisted_39, [
                _createVNode(_component_SectionAreaDelivery, { form: _ctx.dataPartnerArea }, null, 8, ["form"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.detailData.partnerType === 'console' && _ctx.isShowAreaDeliverySection)
            ? (_openBlock(), _createBlock("div", _hoisted_40))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_41, [
            _createVNode(_component_Title, {
              label: _ctx.$t('partnerManagement.detail.contactInfo')
            }, null, 8, ["label"]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode(_component_DataWrapper, { label: "Nama" }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.partnerContactName,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.detailData.partnerContactName = $event)),
                      placeholder: _ctx.$t('partnerManagement.list.enterName')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode("div", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.partnerContactPhoneNumber, (phone, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode(_component_DataWrapper, {
                        label: _ctx.$t('partnerManagement.detail.phone'),
                        class: index > 0 ? `my-4` : ``
                      }, {
                        default: _withId(() => [
                          _createVNode("div", null, [
                            _createVNode(_component_lp_input, {
                              prefix: _ctx.districtFieldRules.phoneDialCode,
                              debounce: 500,
                              format: _ctx.formatNumber,
                              modelValue: phone.no,
                              "onUpdate:modelValue": ($event: any) => (phone.no = $event),
                              error: phone.error || _ctx.emptyContactPhone(index),
                              onChange: ($event: any) => (_ctx.validateContactPhone(index)),
                              errorCaption: _ctx.$t('partnerManagement.error.phoneInvalid'),
                              maxLength: "13",
                              placeholder: "e.g 2112341234",
                              "data-testid": `partner-edit-contact-phone-input-${index}`
                            }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "error", "onChange", "errorCaption", "data-testid"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "class"])
                    ]))
                  }), 128)),
                  (_ctx.isMaxContactPhone)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addPhone && _ctx.addPhone(...args))),
                        class: "cursor-pointer flex gap-3 text-red-lp-300 my-4"
                      }, [
                        _hoisted_44,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('partnerManagement.list.addPhone')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.position')
                }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.partnerContactJobTitle,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.detailData.partnerContactJobTitle = $event)),
                      placeholder: _ctx.$t('partnerManagement.list.enterPosition')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.detail.email')
                }, {
                  default: _withId(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.partnerContactEmail,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.detailData.partnerContactEmail = $event)),
                      onChange: _ctx.validateEmail,
                      errorCaption: _ctx.$t('partnerManagement.list.enterEmailError'),
                      error: _ctx.error.contactEmail,
                      placeholder: "e.g email@gmail.com"
                    }, null, 8, ["modelValue", "onChange", "errorCaption", "error"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.partnerContactPhoneNumber, (phone, index) => {
                  return (_openBlock(), _createBlock(_component_DataWrapper, { key: index }, {
                    default: _withId(() => [
                      _withDirectives(_createVNode("img", {
                        src: _imports_1,
                        class: "cursor-pointer my-1",
                        onClick: ($event: any) => (_ctx.removePhoneNumber(index)),
                        alt: "x-gray"
                      }, null, 8, ["onClick"]), [
                        [_vShow, index === 1]
                      ]),
                      _withDirectives(_createVNode("img", {
                        src: _imports_1,
                        class: "cursor-pointer",
                        onClick: ($event: any) => (_ctx.removePhoneNumber(index)),
                        style: {"margin-top":"45px"},
                        alt: "x-gray."
                      }, null, 8, ["onClick"]), [
                        [_vShow, index > 1]
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])
          ]),
          _hoisted_46,
          _createVNode("div", _hoisted_47, [
            _createVNode(_component_Title, { label: "Periode Kontrak" }),
            _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('partnerManagement.list.accountWillActive')), 1),
            _createVNode("div", _hoisted_49, [
              _createVNode("div", _hoisted_50, [
                _createVNode(_component_DataWrapper, { label: "Dimulai Dari" }, {
                  default: _withId(() => [
                    _createVNode(_component_DatePicker, {
                      class: "my-2",
                      modelValue: _ctx.detailData.partnerStartContract,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.detailData.partnerStartContract = $event)),
                      maxDate: new Date(),
                      disabled: ""
                    }, null, 8, ["modelValue", "maxDate"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_51, [
                _createVNode(_component_DataWrapper, { label: "Sampai" }, {
                  default: _withId(() => [
                    _createVNode(_component_DatePicker, {
                      class: "my-2",
                      modelValue: _ctx.detailData.partnerEndContract,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.detailData.partnerEndContract = $event)),
                      minDate: 
                    new Date(new Date().setDate(new Date().getDate() + 1))
                  
                    }, null, 8, ["modelValue", "minDate"])
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.detailData.partnerType === 'pos')
              ? (_openBlock(), _createBlock("div", _hoisted_52, [
                  _createVNode("div", _hoisted_53, [
                    _createVNode(_component_FileAttachment, {
                      photos: _ctx.filesView,
                      onUpdateFiles: _ctx.updateFiles,
                      onSetLoadingUpload: _ctx.setLoadingUpload
                    }, null, 8, ["photos", "onUpdateFiles", "onSetLoadingUpload"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.detailData.partnerType === 'pos')
              ? (_openBlock(), _createBlock("div", _hoisted_54, [
                  _hoisted_55,
                  _createVNode(_component_Title, {
                    label: _ctx.$t('partnerManagement.detail.additionalInfo')
                  }, null, 8, ["label"]),
                  _createVNode("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _createVNode(_component_DataWrapper, {
                        label: _ctx.$t('partnerManagement.detail.saldoDeposit')
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_lp_input, {
                            modelValue: _ctx.detailData.partnerPosSaldoDepositFormated,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.detailData.partnerPosSaldoDepositFormated = $event)),
                            prefix: _ctx.districtCurrencyPrefix,
                            format: _ctx.formatDebitBalance,
                            placeholder: _ctx.$t('partnerManagement.detail.enterDeposit'),
                            "data-testid": "partner-edit-saldo-deposit-input"
                          }, null, 8, ["modelValue", "prefix", "format", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_58,
          _createVNode("div", _hoisted_59, [
            _createVNode(_component_Title, {
              label: _ctx.$t('partnerManagement.detail.bankInfo'),
              hint: _ctx.$t('partnerManagement.list.optional')
            }, null, 8, ["label", "hint"]),
            (_ctx.beneficiaryDetail.bankAccountName)
              ? (_openBlock(), _createBlock("div", _hoisted_60, [
                  (_ctx.beneficiaryDetail.bankAccountLogo)
                    ? (_openBlock(), _createBlock("div", _hoisted_61, [
                        _createVNode("img", {
                          src: _ctx.beneficiaryDetail.bankAccountLogo,
                          class: "w-28",
                          alt: "bank"
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_62, [
                    _createVNode("p", null, _toDisplayString(_ctx.beneficiaryDetail.bankAccountLabel), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.beneficiaryDetail.bankAccountNumber), 1),
                    _createVNode("p", null, [
                      _hoisted_63,
                      _createVNode("span", _hoisted_64, _toDisplayString(_ctx.beneficiaryDetail.bankAccountName), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.beneficiaryDetail.bankAccountEmail), 1)
                  ]),
                  _createVNode("div", _hoisted_65, [
                    (_ctx.showAddOrDeleteBankAccountButton)
                      ? (_openBlock(), _createBlock(_component_button_fill, {
                          key: 0,
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onDeleteBank())),
                          title: _ctx.$t('Hapus'),
                          class: "text-red-lp-300 px-8",
                          style: {"background-color":"white"}
                        }, null, 8, ["title"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('partnerManagement.list.noBank')), 1),
                  (_ctx.showAddOrDeleteBankAccountButton)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onShowAddBank(true))),
                        title: _ctx.$t('partnerManagement.list.addAccount'),
                        class: "bg-red-lp-300 px-8",
                        style: {"width":"237px"}
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          (_ctx.detailData.partnerType === 'pos')
            ? (_openBlock(), _createBlock("div", _hoisted_66))
            : _createCommentVNode("", true),
          (_ctx.detailData.partnerType === 'pos')
            ? (_openBlock(), _createBlock("div", _hoisted_67, [
                _createVNode(_component_Title, {
                  label: _ctx.$t('partnerManagement.list.referral')
                }, null, 8, ["label"]),
                _createVNode("div", _hoisted_68, [
                  _createVNode("div", _hoisted_69, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.referral')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          disabled: "",
                          modelValue: _ctx.detailData.partnerReferralCode,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.detailData.partnerReferralCode = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createVNode("div", _hoisted_70, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('partnerManagement.list.referral')
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          disabled: "",
                          modelValue: _ctx.detailData.partnerReferrerCode,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.detailData.partnerReferrerCode = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        "sub-data": _withId(() => [
          _createVNode("div", _hoisted_71, [
            _createVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('partnerManagement.list.statusKontrak')), 1),
            _createVNode("div", _hoisted_73, [
              _createVNode("div", _hoisted_74, [
                _createVNode("div", {
                  class: ["rounded-full px-2 py-0 font-medium", _ctx.styleStatus]
                }, [
                  _createVNode("span", _hoisted_75, _toDisplayString(_ctx.detailData.partnerContractStatus), 1)
                ], 2)
              ])
            ]),
            _createVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('partnerManagement.list.statusPartner')), 1),
            _createVNode("div", _hoisted_77, [
              _createVNode("div", _hoisted_78, [
                (_ctx.detailData.partnerIsBanned)
                  ? (_openBlock(), _createBlock("div", _hoisted_79, [
                      _hoisted_80,
                      _createTextVNode(_toDisplayString(_ctx.$t('partnerManagement.list.freezed')), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_81, "-"))
              ])
            ]),
            _hoisted_82,
            _createVNode("div", _hoisted_83, [
              _createVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('partnerManagement.detail.createdAt')), 1),
              _createVNode("div", _hoisted_85, _toDisplayString(_ctx.formatDate(_ctx.detailData.partnerCreatedAt)), 1),
              _createVNode("div", _hoisted_86, _toDisplayString(_ctx.detailData.partnerCreatedBy), 1)
            ]),
            _createVNode("div", _hoisted_87, [
              _createVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('partnerManagement.detail.dateChanged')), 1),
              _createVNode("div", _hoisted_89, _toDisplayString(_ctx.formatDate(_ctx.detailData.partnerUpdatedAt)), 1),
              _createVNode("div", _hoisted_90, _toDisplayString(_ctx.detailData.partnerUpdatedBy), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "onBack", "onConfirm", "loading"])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCreate,
      onClose: _ctx.onCloseConfirmation,
      title: _ctx.$t('Konfirmasi Perubahan'),
      message: 
      `${_ctx.$t('Anda yakin ingin menyimpan perubahan detail Partner')} “${_ctx.detailData.partnerName}” ?`
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('Simpan'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmation]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('Perubahan Berhasil Disimpan !'),
      message: `${_ctx.$t('partnerManagement.route.detailPartner')} “${_ctx.detailData.partnerName}” ${_ctx.$t('partnerManagement.list.successChange')}.`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin ingin keluar ?'),
      message: _ctx.$t('Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('Keluar'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    (_ctx.showAddBank)
      ? (_openBlock(), _createBlock(_component_ModalAddBank, {
          key: 0,
          formType: "edit"
        }))
      : _createCommentVNode("", true)
  ], 64))
})